module.exports = __webpack_public_path__ + "img/back_32.fb44a5d0.svg";